(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {
    if (typeof jQuery === 'undefined' || typeof jQuery.fn.validate === 'undefined') {
      return;
    }

    $('.form-validate').each(function () {
      var $form = $(this);

      $form.validate({
        errorElement: 'span',
        errorClass: 'error-msg',

        errorPlacement: function (error, element) {
          error.appendTo(element.closest('.form-line'));
        },

        highlight: function (element) {
          $(element).closest('.form-line').addClass('error');
        },

        unhighlight: function (element) {
          $(element).closest('.form-line').removeClass('error');
        },

        submitHandler: function (form) {
          var submitButton = form.querySelector('button[type=submit]');

          if (submitButton) {
            submitButton.disabled = true;
            submitButton.style.opacity = '0.5';
          }

          var action =
            form.getAttribute('action') ||
            'https://mail-api.purekana.com/mailer';

          $.ajax({
            type: form.getAttribute('method') || 'POST',
            url: action,
            data: new FormData(form),
            processData: false,
            contentType: false,
            cache: false,

            success: function (response) {
              if (response && response.success) {
                var successTrigger = document.getElementById('trigger-success');
                if (successTrigger) {
                  successTrigger.click();
                }
                form.reset();
              } else {
                var errorTrigger = document.getElementById('trigger-error');
                if (errorTrigger) {
                  errorTrigger.click();
                }
              }
            },

            error: function () {
              var errorTrigger = document.getElementById('trigger-error');
              if (errorTrigger) {
                errorTrigger.click();
              }
            },

            complete: function () {
              if (submitButton) {
                setTimeout(function () {
                  submitButton.disabled = false;
                  submitButton.style.opacity = '1';
                }, 3000);
              }
            }
          });

          return false;
        }
      });
    });
  });
})();
